import styled from '@emotion/styled';

export const CardPadding = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xxl};
  padding: ${({theme}) => theme.padding.desktop.lg};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.xl};
  }
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.lg};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.md};
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({theme}) => theme.color.neutral.grey_100};
`;

export const LabelContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;
